import {createHttpLock} from '@raison/network-facade';
import React, {useState} from 'react';
import {useLockEffect} from '~/library/network-facade';
import {RsnButton, RsnDialog} from '~/library/ui-kit';
import {DialogRegistration} from '../model/DialogRegistration';

const registration = DialogRegistration.createNonClosable({
    name: 'CriticalErrorDialog',
    Component: () => {
        const [reloading, setReloading] = useState(false);

        function onReload() {
            if (reloading) return;
            setReloading(true);
            window.location.reload();
        }

        useLockEffect(CriticalErrorMsg.httpLock);

        const title = 'Something went wrong';
        const details =
            'We’re sorry that you have to experience some problems. ' +
            "Don't worry, we'll fix it. Please try again later.";
        return (
            <RsnDialog.Window placement='bottom'>
                <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status='alert' />}}>
                    {title}
                </RsnDialog.CenteredHeader>
                <RsnDialog.Body>{details}</RsnDialog.Body>
                <RsnDialog.Footer column>
                    <RsnButton.Primary onClick={onReload}>
                        {reloading ? 'Reloading...' : `Reload the app`}
                    </RsnButton.Primary>
                </RsnDialog.Footer>
            </RsnDialog.Window>
        );
    },
});

export const CriticalErrorMsg = {
    ...registration,
    httpLock: createHttpLock(),
};
